export const CPF_VALIDATION_REGEX = /^(\d{3}\.?\d{3}\.?\d{3}-?\d{2})$/;
export const PHONE_VALIDATION_REGEX = /^(?:55)?\d{2}(?:9\d{8}|[2-5]\d{7})$/;
export const CNPJ_VALIDATION_REGEX =
  /^([A-Z0-9]{2}\.?[A-Z0-9]{3}\.?[A-Z0-9]{3}\/?[A-Z0-9]{4}-?\d{2})/i;
export const CNPJ_CPF_VALIDATION_REGEX =
  /^(\d{3}\.?\d{3}\.?\d{3}-?\d{2})$|^([A-Z0-9]{2}\.?[A-Z0-9]{3}\.?[A-Z0-9]{3}\/?[A-Z0-9]{4}-?\d{2})$/i;

// prettier-ignore
export const MASKS = {
  number: [...Array(999)].map(() => /\d/),
  taxDocumentCPF: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
  taxDocumentCNPJ: [/[A-Z0-9]/i, /[A-Z0-9]/i, '.', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, '.', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, '/', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, '-', /\d/, /\d/],
  taxDocumentCNPJCPF: rawValue => {
    const isCnpj = /[A-Z]/i.test(rawValue) || rawValue.replace(/[^A-Z0-9]/gi, '').length > 11;
    return isCnpj
      ? MASKS.taxDocumentCNPJ
      : MASKS.taxDocumentCPF;
  },
  phoneNumber: rawValue =>
    rawValue.replace(/[^\d]/g, '').length > 10
      ? ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
      : ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  fullPhoneNumber: rawValue => {
    const digits = rawValue.replace(/\D/g, '');
    const masks = {
      14: ['+', /\d/, /\d/, /\d/, ' ', '(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      13: ['+', /\d/, /\d/, ' ', '(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      12: ['+', /\d/, ' ', '(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      11: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      10: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    };
    return masks[Math.min(digits.length, 14)] || masks[10];
  },
  postalCode:  [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
  percentageNumber: rawValue =>
    rawValue.length < 2
      ? [/\d/]
      : [0, '.', /\d/, /\d/, /\d/, /\d/],
  time: [/\d/, /\d/, ':', /\d/, /\d/],
  ncm: [/\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/],
  threeDigits: [/\d/, /\d/, /\d/],
  fourDigits: [/\d/, /\d/, /\d/, /\d/],
  sixDigits: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
  currencyBRL: rawValue => {
    if (rawValue.length < 3) return [/\d/, /\d/]
    const newValue = [...rawValue.replace(/[^\d]/g, '')].map(() => /\d/ )
    newValue.splice(-2, 0, ',')
    if (newValue.length > 6) newValue.splice(-6, 0, '.')
    if (newValue.length > 10) newValue.splice(-10, 0, '.')
    if (newValue.length > 14) newValue.splice(-14, 0, '.')
    if (newValue.length > 16) newValue.splice(-16, 1)
    return newValue
  },
  slug: rawValue => {
    const newValue = rawValue.replace(/[^\w\d-_]/g, '');
    return [...newValue].map(() => /[\w\d-_]/);
  },
};

export const uppercasePipe = conformedValue =>
  typeof conformedValue === 'string' ? conformedValue.toUpperCase() : conformedValue;

export const unmask = value => {
  const stringValue = value.toString();
  return stringValue.replace(/\D/g, '');
};

export const isValidCpf = value => {
  if (!value) return true;
  return CPF_VALIDATION_REGEX.test(value);
};

export const isValidPhoneNumber = value => {
  if (!value) return true;
  return PHONE_VALIDATION_REGEX.test(unmask(value));
};

export const normalizeMaskedValue = value => {
  if (value === null || value === undefined) return value;

  const stringValue = String(value).trim();
  if (!stringValue) return '';

  return unmask(stringValue);
};

export const unmaskCNPJ = value =>
  String(value)
    .replace(/[^A-Z0-9]/gi, '')
    .toUpperCase();

export const maskPhone = value =>
  value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, '+$1 ($2) $3-$4')
    .replace(/(\d{2})(\d{2})(\d{4})(\d{4})/, '+$1 ($2) $3-$4')
    .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
    .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

export const maskCPF = value =>
  value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');

export const maskCNPJ = value => {
  const v = String(value)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
  return v
    .replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
    .replace(/^([A-Z0-9]{2}\.[A-Z0-9]{3})([A-Z0-9])/, '$1.$2')
    .replace(/^([A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3})([A-Z0-9])/, '$1/$2')
    .replace(/^([A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
};

export const maskCNPJCPF = value => {
  const hasLetters = /[A-Z]/i.test(value);
  const { length } = String(value).replace(/[^A-Z0-9]/gi, '');
  const isCnpj = hasLetters || length > 11;
  return isCnpj ? maskCNPJ(value) : maskCPF(value);
};

export const maskNCM = value =>
  value.replace(/\D/g, '').replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3');

export const maskCEP = value =>
  value
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1');
